import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function OnlyWithoutComparisonReadOnly({ children }) {
    const { comparisonReadOnly } = useBoundContext()
    if (!comparisonReadOnly) {
        return children
    }
    return null
}
